export const MAPTILER_KEY = 'Kaj7hj4spq6OTB0wtwjG';
export const MAPTILER_STREET_STYLE =
  'https://api.maptiler.com/maps/streets-v2/style.json';
export const MAPTILER_CUSTOM_STYLE =
  'https://api.maptiler.com/maps/c009d368-07c5-496e-8047-e69432e7af2b/style.json';
